import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';

/**
 * Gate für den Admin-Bereich. Prüft ausschließlich die Custom Claim -
 * die kann nur serverseitig gesetzt werden. Die Firestore-Rules prüfen
 * dieselbe Claim noch einmal; dieses Gate ist reine UI-Bequemlichkeit,
 * keine Sicherheitsgrenze.
 */
export default function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="mt-loading">
        <div className="mt-spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/intern" replace />;
  }

  return children;
}
